import Color from "colorjs.io";

//Get first letter of each word, limit to 2 letters, and uppercase them
export const getInitials = (name: string): string => {
    return name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("")
        .substring(0, 2);
};

//Get random color based on hash of string, ensuring good contrast with text
export const getColor = (str: string): { background: string; text: string } => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let c = (hash & 0x00ffffff).toString(16).toUpperCase();
    const hex = "#" + "00000".substring(0, 6 - c.length) + c;

    const color = new Color(hex);
    const oklch = color.to("oklch");

    // Force colors into a range that works well with white text
    // Keep hue and some chroma, but clamp lightness to 0.35-0.55 for rich, readable colors
    const lightness = oklch.coords[0] ?? 0.5;
    if (lightness > 0.55) {
        oklch.coords[0] = 0.55;
    } else if (lightness < 0.35) {
        oklch.coords[0] = 0.35;
    }

    // Ensure sufficient chroma for vibrant colors (but not too much)
    const chroma = oklch.coords[1] ?? 0.1;
    if (chroma < 0.08) {
        oklch.coords[1] = 0.08;
    } else if (chroma > 0.2) {
        oklch.coords[1] = 0.2;
    }

    const adjustedColor = oklch.to("srgb");
    const background = adjustedColor.toString({ format: "hex" });

    // With this lightness range, white text always works best
    return { background, text: "#ffffff" };
};
